let utterance = null;
function read(text, rate, voice, ...callbacks) {
    utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = rate;
    utterance.voice = voice;
    utterance.onend = utterance.onerror = () => {
        utterance = null;
        callbacks.forEach(callback => callback === null || callback === void 0 ? void 0 : callback());
    };
    speechSynthesis.speak(utterance);
}
function isUtteranceEnded() {
    return utterance === null;
}
function getAvailableVoices(lang) {
    return window.speechSynthesis.getVoices().filter(v => v.lang.startsWith(lang));
}
export default {
    read,
    isUtteranceEnded,
    getAvailableVoices
};
